import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { DealCard } from "@/components/home/FeaturedDeals";

export default function Deals() {
  const [deals, setDeals] = useState([]);
  useEffect(() => { api.get("/deals").then(({ data }) => setDeals(data)).catch(() => {}); }, []);

  return (
    <div data-testid="deals-page">
      <PageHero
        kicker="This week's best"
        title="Travel deals that move fast"
        subtitle="Curated flight + hotel discounts from leading partners. Affiliate links — we may earn a small commission."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Deals" }]} />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {deals.map((d) => <DealCard key={d.id} deal={d} />)}
        </div>
      </div>
    </div>
  );
}
